export default {"src":"/_next/static/media/doubles-icon.dd005722.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};